export const PAPERSHELF_CATEGORIES = [
  'Cloud Security',
  'Data Security',
  'Identity Security',
  'Database',
  'Design Pattern',
  'Cloud',
  'Distributed Systems',
  'Storage',
  'Performance',
  'Architecture',
  'Data Streaming',
  'Big Data',
  'Real-time Processing'
];

export const papers = [
  {
    id: 'dynamodb-streams-architecture',
    title: "DynamoDB Streams: Building Real-time Applications with Change Data Capture",
    authors: "Amazon Web Services",
    startedAt: "January 2025",
    category: "Data Streaming",
    link: "https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/Streams.html",
    status: "Currently Reading"
  },
  {
    id: 'mapreduce-simplified-data-processing',
    title: "MapReduce: Simplified Data Processing on Large Clusters",
    authors: "Google Research",
    startedAt: "July 2025",
    category: "Distributed Systems",
    link: "https://research.google/pubs/pub62/",
    status: "Completed"
  },
  {
    id: 'cache-efficient-topk-aggregation',
    title: "Cache-Efficient Top-k Aggregation over High Cardinality Large Datasets",
    authors: "Bing Research (Microsoft)",
    startedAt: "June 2025",
    category: "Caching",
    link: "https://www.microsoft.com/en-us/research/publication/cache-efficient-top-k-aggregation-over-high-cardinality-large-datasets/",
    status: "Completed"
  },
  {
    id: 'monitoring-distributed-systems',
    title: "Monitoring Distributed Systems",
    authors: "Google SRE Team",
    startedAt: "May 2025",
    category: "Observability",
    link: "https://sre.google/sre-book/monitoring-distributed-systems/",
    status: "Completed"
  },
  {
    id: 'aws-well-architected-framework',
    title: "AWS Well-Architected Framework",
    authors: "Amazon Web Services",
    startedAt: "April 2025",
    category: "Cloud Architecture",
    link: "https://docs.aws.amazon.com/wellarchitected/latest/framework/welcome.html",
    status: "Completed"
  },
  {
    id: 'dynamodb-nosql-database-service',
    title: "DynamoDB: A NoSQL Database Service for All Scale Applications",
    authors: "Amazon Web Services",
    startedAt: "March 2025",
    category: "Database",
    link: "https://www.usenix.org/system/files/atc22-elhemali.pdf",
    status: "Completed"
  },
  {
    id: 'amazon-s3-best-practices',
    title: "Amazon S3 Best Practices",
    authors: "Amazon Web Services",
    startedAt: "March 2025",
    category: "Storage",
    link: "https://d1.awsstatic.com/whitepapers/AmazonS3BestPractices.pdf",
    status: "Completed"
  }
];
